<template>
  <nav class="app-bottom-nav" :aria-label="$t('bottomNav.ariaLabel')">
    <router-link
      v-for="item in items"
      :key="item.key"
      class="app-bottom-nav__item"
      :class="{ 'is-active': activeKey === item.key }"
      :to="item.to"
      :aria-current="activeKey === item.key ? 'page' : null"
    >
      <span class="app-bottom-nav__icon-wrap">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path :d="item.iconPath" />
        </svg>
      </span>
      <span class="app-bottom-nav__label">{{ $t(item.labelKey) }}</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'AppBottomNav',
  computed: {
    activeKey() {
      const path = this.$route.path;
      if (path === '/goods/list') return 'products';
      if (path === '/profile/index') return 'account';
      return 'home';
    },
    items() {
      return [
        {
          key: 'home',
          to: '/index',
          iconPath: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z',
          labelKey: 'bottomNav.home',
        },
        {
          key: 'products',
          to: '/goods/list',
          iconPath: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03L20.88 5H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z',
          labelKey: 'bottomNav.products',
        },
        {
          key: 'account',
          to: '/profile/index',
          iconPath: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z',
          labelKey: 'bottomNav.account',
        },
      ];
    },
  },
};
</script>

<style lang="less" scoped>
.app-bottom-nav {
  position: fixed;
  z-index: 100;
  left: 50%;
  bottom: 0;
  display: flex;
  width: 100%;
  max-width: 750px;
  min-height: 132px;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  gap: 12px;
  box-sizing: border-box;
  background: #FFFFFF;
  border-top: 2px solid #E5EAF3;
  box-shadow: 0 -2px 8px rgba(7, 13, 63, 0.04);
  transform: translateX(-50%);
}

.app-bottom-nav__item {
  display: flex;
  flex: 1;
  min-width: 0;
  min-height: 104px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 20px;
  color: #6B7280;
  text-decoration: none;

  &.is-active {
    background: #EAF3FF;

    .app-bottom-nav__icon-wrap {
      background: #FFFFFF;
      color: #0B45FF;
    }

    .app-bottom-nav__label {
      color: #070D3F;
      font-weight: 600;
    }
  }
}

.app-bottom-nav__icon-wrap {
  display: flex;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #F8FAFF;

  color: #6B7280;

  svg {
    display: block;
    width: 36px;
    height: 36px;
    fill: currentColor;
  }
}

.app-bottom-nav__label {
  max-width: 100%;
  margin-top: 4px;
  overflow: hidden;
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
